import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-fcpo',
  styleUrls: ['./lmo-frac-fcpo.component.scss'],
  templateUrl: './lmo-frac-fcpo.component.html',
})
export class LmoFracFcpoComponent implements OnInit {
  public navLinks: { path: string | string[]; label: string }[] = [
    { path: ['add'], label: 'Add' },
    { path: ['manage'], label: 'Manage' },
    { path: ['loaders'], label: 'In-Network Loaders' },
    { path: ['manage_purchase_orders'], label: 'Manage POs' },
    { path: ['loader_directions'], label: 'Loader Directions' },
  ];

  constructor(private cd: ChangeDetectorRef) {}

  public ngOnInit() {
    // Makes sure that the correct tab is highlighted, since we are using onPush change detection strategy
    Promise.resolve().then(() => {
      this.cd.markForCheck();
    });
  }

  public trackByPath(_index: number, link: { path: string | string[]; label: string }): string | string[] {
    return link.path;
  }
}
